import HomePage from "./pages/home_page";

function App() {
  return (
    <HomePage />
  );
}

export default App;
